var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 28,
    viewBox: "0 0 67 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2011_5819",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 67,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2011_5819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31907 5.35884C6.34792 5.35868 6.37952 5.35818 6.41363 5.35764C7.0845 5.34706 8.724 5.32119 9.43838 7.55649C9.94406 9.13877 10.7496 11.7306 11.8549 15.332H12.3051C13.4905 11.5352 14.3048 8.94332 14.748 7.55649C15.4612 5.3251 17.18 5.34697 18.0135 5.35758C18.0665 5.35825 18.116 5.35888 18.1614 5.35888L24.0136 5.35889V22.2365H18.0489V12.2902H17.6489L14.3239 22.2365H9.83618L6.51116 12.2829H6.11118V22.2365H0.146484V5.35889L6.31907 5.35884ZM32.5795 5.35896V15.3126H33.0553L37.0999 7.12779C37.8851 5.499 39.5584 5.35896 39.5584 5.35896H45.3304V22.2366H39.2412V12.2829H38.7653L34.8001 20.4677C34.0149 22.0892 32.2623 22.2366 32.2623 22.2366H26.4902V5.35896H32.5795ZM59.9069 17.209C62.8601 17.209 65.5275 15.6109 66.3769 13.3793H47.7306V22.2366H53.5211V17.209H59.9069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4434 5H47.9756C48.2723 8.7141 51.6829 11.8936 55.2135 11.8936H66.8858C67.5594 8.80676 65.2406 5 60.4434 5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.0c19ec7b929198791311bb081bc737ed.svg";
export { ForwardRef as ReactComponent };